import { useEntitlements } from '../context/EntitlementsContext';

export function useLimit(name) {
  const ent = useEntitlements();
  const limit = ent?.limits?.[name] ?? -1;
  const allowed = (count) => limit < 0 || count <= limit;
  return { allowed, limit, plan: ent?.plan, loading: ent?.__loading, error: ent?.__error };
}
